module.exports = __webpack_public_path__ + "static/media/iconfinder_website_-_home_3440837.772b6b9a.png";